import lottie from 'lottie-web/build/player/lottie_light'
import { defineElement } from '@lordicon/element'

// define "lord-icon" custom element with default properties
defineElement(lottie.loadAnimation)
